module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZwAAAACCAYAAABsWmq+AAAAAXNSR0IArs4c6QAAAEdJREFUSA1jfPfuHf/379+9GEbBaAiMhsBoCIyGwGgI0CgEuLm5d7D8+/ePh5GR0ZdGdowaOxoCoyEwGgKjITAaAgzAjs1xAMfkDemR8dJJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/xian.png
// module id = 272
// module chunks = 1